import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-ucep',
  templateUrl: './events-ucep.component.html',
  styleUrls: ['./events-ucep.component.scss'],
})
export class EventsUcepComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/ucep/1.jpg',
      thumbnail: 'assets/img/school/events/ucep/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ucep/2.jpg',
      thumbnail: 'assets/img/school/events/ucep/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ucep/3.jpg',
      thumbnail: 'assets/img/school/events/ucep/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ucep/4.jpg',
      thumbnail: 'assets/img/school/events/ucep/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ucep/5.jpg',
      thumbnail: 'assets/img/school/events/ucep/5.jpg',
      alt: 'Image 01',
    },
  ];
}
